/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightLoyaltyAttachment } from "./FlightLoyaltyAttachment";
import {
  FlightLoyaltyAttachmentFromJSON,
  FlightLoyaltyAttachmentFromJSONTyped,
  FlightLoyaltyAttachmentToJSON,
  FlightLoyaltyAttachmentToJSONTyped,
} from "./FlightLoyaltyAttachment";
import type { FlightSupportAttention } from "./FlightSupportAttention";
import {
  FlightSupportAttentionFromJSON,
  FlightSupportAttentionFromJSONTyped,
  FlightSupportAttentionToJSON,
  FlightSupportAttentionToJSONTyped,
} from "./FlightSupportAttention";
import type { FlightSupportNextAction } from "./FlightSupportNextAction";
import {
  FlightSupportNextActionFromJSON,
  FlightSupportNextActionFromJSONTyped,
  FlightSupportNextActionToJSON,
  FlightSupportNextActionToJSONTyped,
} from "./FlightSupportNextAction";
import type { FlightSupportCapability } from "./FlightSupportCapability";
import {
  FlightSupportCapabilityFromJSON,
  FlightSupportCapabilityFromJSONTyped,
  FlightSupportCapabilityToJSON,
  FlightSupportCapabilityToJSONTyped,
} from "./FlightSupportCapability";
import type { FlightPaymentApprovalProjection } from "./FlightPaymentApprovalProjection";
import {
  FlightPaymentApprovalProjectionFromJSON,
  FlightPaymentApprovalProjectionFromJSONTyped,
  FlightPaymentApprovalProjectionToJSON,
  FlightPaymentApprovalProjectionToJSONTyped,
} from "./FlightPaymentApprovalProjection";
import type { FlightSupportRecovery } from "./FlightSupportRecovery";
import {
  FlightSupportRecoveryFromJSON,
  FlightSupportRecoveryFromJSONTyped,
  FlightSupportRecoveryToJSON,
  FlightSupportRecoveryToJSONTyped,
} from "./FlightSupportRecovery";
import type { FlightSupportEvent } from "./FlightSupportEvent";
import {
  FlightSupportEventFromJSON,
  FlightSupportEventFromJSONTyped,
  FlightSupportEventToJSON,
  FlightSupportEventToJSONTyped,
} from "./FlightSupportEvent";

/**
 * Fields outside the required identity envelope may be omitted during independent producer/client version skew. Omitted means unavailable from that producer version and is distinct from explicit null, an empty array, zero, or false. Optional non-nullable fields must be omitted rather than emitted as null.
 * @export
 * @interface FlightSupportProjectionResponse
 */
export interface FlightSupportProjectionResponse {
  /**
   * Current verified itinerary revision; zero is the original booking, omission means an older producer.
   * @type {number}
   * @memberof FlightSupportProjectionResponse
   */
  itineraryRevision?: number;
  /**
   * Current verified document count, excluding superseded ticket history. Contains no document identities.
   * @type {number}
   * @memberof FlightSupportProjectionResponse
   */
  activeTicketCount?: number;
  /**
   * Account-free per-traveler attachment evidence; omitted by older producers.
   * @type {Array<FlightLoyaltyAttachment>}
   * @memberof FlightSupportProjectionResponse
   */
  loyaltyAttachments?: Array<FlightLoyaltyAttachment>;
  /**
   * Contract version for this projection; this field is always present and never null.
   * @type {string}
   * @memberof FlightSupportProjectionResponse
   */
  schemaVersion: FlightSupportProjectionResponseSchemaVersionEnum;
  /**
   * Canonical Search booking UUID; this field is always present and never null.
   * @type {string}
   * @memberof FlightSupportProjectionResponse
   */
  bookingId: string;
  /**
   * True because the projection was derived from Search-owned persisted booking state; this field is always present.
   * @type {boolean}
   * @memberof FlightSupportProjectionResponse
   */
  authoritative: boolean;
  /**
   * Persisted booking state version; omitted only during producer version skew and never null when present.
   * @type {number}
   * @memberof FlightSupportProjectionResponse
   */
  stateVersion?: number;
  /**
   * UTC time at which Search assembled the projection; omitted only during producer version skew and never null when present.
   * @type {Date}
   * @memberof FlightSupportProjectionResponse
   */
  asOf?: Date;
  /**
   * Persisted UTC booking update time; omitted only during producer version skew and never null when present.
   * @type {Date}
   * @memberof FlightSupportProjectionResponse
   */
  updatedAt?: Date;
  /**
   * Bounded persisted provider; omitted only during producer version skew and never null when present.
   * @type {string}
   * @memberof FlightSupportProjectionResponse
   */
  provider?: FlightSupportProjectionResponseProviderEnum;
  /**
   * Bounded aggregate booking status; omitted only during producer version skew and never null when present.
   * @type {string}
   * @memberof FlightSupportProjectionResponse
   */
  bookingStatus?: FlightSupportProjectionResponseBookingStatusEnum;
  /**
   * Bounded latest payment-operation status; omitted only during producer version skew and never null when present.
   * @type {string}
   * @memberof FlightSupportProjectionResponse
   */
  paymentStatus?: FlightSupportProjectionResponsePaymentStatusEnum;
  /**
   * Bounded ticketing status derived from durable stage evidence; omitted only during producer version skew and never null when present.
   * @type {string}
   * @memberof FlightSupportProjectionResponse
   */
  ticketingStatus?: FlightSupportProjectionResponseTicketingStatusEnum;
  /**
   * Bounded ticket-settlement state derived from the latest identity-validated settlement evidence, independently of cancellation and refund. Omitted when no settlement scope is known or during producer version skew, and never null when present.
   * @type {string}
   * @memberof FlightSupportProjectionResponse
   */
  ticketSettlementStatus?: FlightSupportProjectionResponseTicketSettlementStatusEnum;
  /**
   * Bounded settlement method from identity-validated consent evidence. Omitted when no safe method is known or during producer version skew, and never null when present.
   * @type {string}
   * @memberof FlightSupportProjectionResponse
   */
  ticketSettlementMethod?: FlightSupportProjectionResponseTicketSettlementMethodEnum;
  /**
   * Count of ticket documents in the identity-validated settlement scope. Omitted when no safe count is known or during producer version skew, and never null when present.
   * @type {number}
   * @memberof FlightSupportProjectionResponse
   */
  ticketSettlementAffectedCount?: number;
  /**
   * Count of ticket documents proven settled. Omitted until durable evidence supplies a safe count or during producer version skew, and never null when present.
   * @type {number}
   * @memberof FlightSupportProjectionResponse
   */
  ticketSettlementSettledCount?: number;
  /**
   * Bounded cancellation status including reserved quote work; omitted only during producer version skew and never null when present.
   * @type {string}
   * @memberof FlightSupportProjectionResponse
   */
  cancellationStatus?: FlightSupportProjectionResponseCancellationStatusEnum;
  /**
   * Bounded aggregate refund status; omitted only during producer version skew and never null when present.
   * @type {string}
   * @memberof FlightSupportProjectionResponse
   */
  refundStatus?: FlightSupportProjectionResponseRefundStatusEnum;
  /**
   * True when a non-null persisted provider order identifier exists; false means this projection has no such evidence. Omitted only during producer version skew and never null when present.
   * @type {boolean}
   * @memberof FlightSupportProjectionResponse
   */
  orderEvidencePresent?: boolean;
  /**
   * True when persisted ticket documents are non-empty; false means this projection has no persisted ticket-document evidence. Omitted only during producer version skew and never null when present.
   * @type {boolean}
   * @memberof FlightSupportProjectionResponse
   */
  ticketEvidencePresent?: boolean;
  /**
   * Bounded approval-only projection for currently eligible prepared compensation operations and durable approvals. An empty array is authoritative when the companion count and truncation fields are present; omission means producer skew and is non-actionable.
   * @type {Array<FlightPaymentApprovalProjection>}
   * @memberof FlightSupportProjectionResponse
   */
  paymentApprovals?: Array<FlightPaymentApprovalProjection>;
  /**
   * Exact eligible and approved count before the bounded payment_approvals cap.
   * @type {number}
   * @memberof FlightSupportProjectionResponse
   */
  paymentApprovalsTotalCount?: number;
  /**
   * True when payment_approvals_total_count exceeds the bounded list length.
   * @type {boolean}
   * @memberof FlightSupportProjectionResponse
   */
  paymentApprovalsTruncated?: boolean;
  /**
   * Complete fixed capability set for this schema version; omitted only during producer version skew and never empty or null when present. Nullable availability is represented on each item, never by item omission.
   * @type {Array<FlightSupportCapability>}
   * @memberof FlightSupportProjectionResponse
   */
  capabilities?: Array<FlightSupportCapability>;
  /**
   * Booking-recovery state only; ordinary lifecycle-delivery and provider-receipt backlog is excluded. Omitted only during producer version skew and never null when present.
   * @type {FlightSupportRecovery}
   * @memberof FlightSupportProjectionResponse
   */
  recovery?: FlightSupportRecovery;
  /**
   * Highest-priority concrete attention decision derived from bounded persisted evidence. Omitted only during producer version skew and never null when present.
   * @type {FlightSupportAttention}
   * @memberof FlightSupportProjectionResponse
   */
  attention?: FlightSupportAttention;
  /**
   * Safe bounded action corresponding to attention. Omitted only during producer version skew and never null when present.
   * @type {FlightSupportNextAction}
   * @memberof FlightSupportProjectionResponse
   */
  nextAction?: FlightSupportNextAction;
  /**
   * Bounded ascending chronology page; an empty array means no events exist in the requested chronology window. Omitted only during producer version skew and never null when present.
   * @type {Array<FlightSupportEvent>}
   * @memberof FlightSupportProjectionResponse
   */
  events?: Array<FlightSupportEvent>;
  /**
   * True when more events follow this page; false means this event page is complete. Omitted only during producer version skew and never null when present.
   * @type {boolean}
   * @memberof FlightSupportProjectionResponse
   */
  truncated?: boolean;
  /**
   * Client-opaque, base64-encoded, booking-bound sequencing cursor for the next event page, or explicit null when truncated is false. It contains internal ordering fields, is not encrypted or signed, and is not an authorization token or integrity proof. The field itself may be omitted only during producer version skew.
   * @type {string}
   * @memberof FlightSupportProjectionResponse
   */
  nextCursor?: string | null;
}

/**
 * @export
 */
export const FlightSupportProjectionResponseSchemaVersionEnum = {
  _1: "1",
} as const;
export type FlightSupportProjectionResponseSchemaVersionEnum =
  (typeof FlightSupportProjectionResponseSchemaVersionEnum)[keyof typeof FlightSupportProjectionResponseSchemaVersionEnum];

/**
 * @export
 */
export const FlightSupportProjectionResponseProviderEnum = {
  Duffel: "duffel",
  Travelport: "travelport",
  Unknown: "unknown",
} as const;
export type FlightSupportProjectionResponseProviderEnum =
  (typeof FlightSupportProjectionResponseProviderEnum)[keyof typeof FlightSupportProjectionResponseProviderEnum];

/**
 * @export
 */
export const FlightSupportProjectionResponseBookingStatusEnum = {
  Created: "created",
  PaymentPending: "payment_pending",
  PaymentAuthorized: "payment_authorized",
  OrderPending: "order_pending",
  OrderCreated: "order_created",
  TicketingPending: "ticketing_pending",
  Ticketed: "ticketed",
  PartiallyTicketed: "partially_ticketed",
  Cancelled: "cancelled",
  Refunded: "refunded",
  Failed: "failed",
  NeedsAttention: "needs_attention",
  Unknown: "unknown",
} as const;
export type FlightSupportProjectionResponseBookingStatusEnum =
  (typeof FlightSupportProjectionResponseBookingStatusEnum)[keyof typeof FlightSupportProjectionResponseBookingStatusEnum];

/**
 * @export
 */
export const FlightSupportProjectionResponsePaymentStatusEnum = {
  NotStarted: "not_started",
  Pending: "pending",
  Authorized: "authorized",
  Captured: "captured",
  Voided: "voided",
  Refunded: "refunded",
  Failed: "failed",
  Unknown: "unknown",
} as const;
export type FlightSupportProjectionResponsePaymentStatusEnum =
  (typeof FlightSupportProjectionResponsePaymentStatusEnum)[keyof typeof FlightSupportProjectionResponsePaymentStatusEnum];

/**
 * @export
 */
export const FlightSupportProjectionResponseTicketingStatusEnum = {
  NotStarted: "not_started",
  Pending: "pending",
  Ticketed: "ticketed",
  PartiallyTicketed: "partially_ticketed",
  Failed: "failed",
  Unknown: "unknown",
} as const;
export type FlightSupportProjectionResponseTicketingStatusEnum =
  (typeof FlightSupportProjectionResponseTicketingStatusEnum)[keyof typeof FlightSupportProjectionResponseTicketingStatusEnum];

/**
 * @export
 */
export const FlightSupportProjectionResponseTicketSettlementStatusEnum = {
  NotRequired: "not_required",
  Pending: "pending",
  VoidPending: "void_pending",
  Voided: "voided",
  NeedsAttention: "needs_attention",
} as const;
export type FlightSupportProjectionResponseTicketSettlementStatusEnum =
  (typeof FlightSupportProjectionResponseTicketSettlementStatusEnum)[keyof typeof FlightSupportProjectionResponseTicketSettlementStatusEnum];

/**
 * @export
 */
export const FlightSupportProjectionResponseTicketSettlementMethodEnum = {
  Void: "void",
} as const;
export type FlightSupportProjectionResponseTicketSettlementMethodEnum =
  (typeof FlightSupportProjectionResponseTicketSettlementMethodEnum)[keyof typeof FlightSupportProjectionResponseTicketSettlementMethodEnum];

/**
 * @export
 */
export const FlightSupportProjectionResponseCancellationStatusEnum = {
  NotRequested: "not_requested",
  QuotePending: "quote_pending",
  QuoteReady: "quote_ready",
  ConfirmationPending: "confirmation_pending",
  Cancelled: "cancelled",
  Failed: "failed",
  Unknown: "unknown",
} as const;
export type FlightSupportProjectionResponseCancellationStatusEnum =
  (typeof FlightSupportProjectionResponseCancellationStatusEnum)[keyof typeof FlightSupportProjectionResponseCancellationStatusEnum];

/**
 * @export
 */
export const FlightSupportProjectionResponseRefundStatusEnum = {
  NotRequested: "not_requested",
  Pending: "pending",
  Refunded: "refunded",
  PartiallyRefunded: "partially_refunded",
  Failed: "failed",
  Unknown: "unknown",
} as const;
export type FlightSupportProjectionResponseRefundStatusEnum =
  (typeof FlightSupportProjectionResponseRefundStatusEnum)[keyof typeof FlightSupportProjectionResponseRefundStatusEnum];

/**
 * Check if a given object implements the FlightSupportProjectionResponse interface.
 */
export function instanceOfFlightSupportProjectionResponse(
  value: object
): value is FlightSupportProjectionResponse {
  if (!("schemaVersion" in value) || value["schemaVersion"] === undefined)
    return false;
  if (!("bookingId" in value) || value["bookingId"] === undefined) return false;
  if (!("authoritative" in value) || value["authoritative"] === undefined)
    return false;
  return true;
}

export function FlightSupportProjectionResponseFromJSON(
  json: any
): FlightSupportProjectionResponse {
  return FlightSupportProjectionResponseFromJSONTyped(json, false);
}

export function FlightSupportProjectionResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightSupportProjectionResponse {
  if (json == null) {
    return json;
  }
  return {
    itineraryRevision:
      json["itinerary_revision"] == null
        ? undefined
        : json["itinerary_revision"],
    activeTicketCount:
      json["active_ticket_count"] == null
        ? undefined
        : json["active_ticket_count"],
    loyaltyAttachments:
      json["loyalty_attachments"] == null
        ? undefined
        : (json["loyalty_attachments"] as Array<any>).map(
            FlightLoyaltyAttachmentFromJSON
          ),
    schemaVersion: json["schema_version"],
    bookingId: json["booking_id"],
    authoritative: json["authoritative"],
    stateVersion:
      json["state_version"] == null ? undefined : json["state_version"],
    asOf: json["as_of"] == null ? undefined : new Date(json["as_of"]),
    updatedAt:
      json["updated_at"] == null ? undefined : new Date(json["updated_at"]),
    provider: json["provider"] == null ? undefined : json["provider"],
    bookingStatus:
      json["booking_status"] == null ? undefined : json["booking_status"],
    paymentStatus:
      json["payment_status"] == null ? undefined : json["payment_status"],
    ticketingStatus:
      json["ticketing_status"] == null ? undefined : json["ticketing_status"],
    ticketSettlementStatus:
      json["ticket_settlement_status"] == null
        ? undefined
        : json["ticket_settlement_status"],
    ticketSettlementMethod:
      json["ticket_settlement_method"] == null
        ? undefined
        : json["ticket_settlement_method"],
    ticketSettlementAffectedCount:
      json["ticket_settlement_affected_count"] == null
        ? undefined
        : json["ticket_settlement_affected_count"],
    ticketSettlementSettledCount:
      json["ticket_settlement_settled_count"] == null
        ? undefined
        : json["ticket_settlement_settled_count"],
    cancellationStatus:
      json["cancellation_status"] == null
        ? undefined
        : json["cancellation_status"],
    refundStatus:
      json["refund_status"] == null ? undefined : json["refund_status"],
    orderEvidencePresent:
      json["order_evidence_present"] == null
        ? undefined
        : json["order_evidence_present"],
    ticketEvidencePresent:
      json["ticket_evidence_present"] == null
        ? undefined
        : json["ticket_evidence_present"],
    paymentApprovals:
      json["payment_approvals"] == null
        ? undefined
        : (json["payment_approvals"] as Array<any>).map(
            FlightPaymentApprovalProjectionFromJSON
          ),
    paymentApprovalsTotalCount:
      json["payment_approvals_total_count"] == null
        ? undefined
        : json["payment_approvals_total_count"],
    paymentApprovalsTruncated:
      json["payment_approvals_truncated"] == null
        ? undefined
        : json["payment_approvals_truncated"],
    capabilities:
      json["capabilities"] == null
        ? undefined
        : (json["capabilities"] as Array<any>).map(
            FlightSupportCapabilityFromJSON
          ),
    recovery:
      json["recovery"] == null
        ? undefined
        : FlightSupportRecoveryFromJSON(json["recovery"]),
    attention:
      json["attention"] == null
        ? undefined
        : FlightSupportAttentionFromJSON(json["attention"]),
    nextAction:
      json["next_action"] == null
        ? undefined
        : FlightSupportNextActionFromJSON(json["next_action"]),
    events:
      json["events"] == null
        ? undefined
        : (json["events"] as Array<any>).map(FlightSupportEventFromJSON),
    truncated: json["truncated"] == null ? undefined : json["truncated"],
    nextCursor: json["next_cursor"] == null ? undefined : json["next_cursor"],
  };
}

export function FlightSupportProjectionResponseToJSON(
  json: any
): FlightSupportProjectionResponse {
  return FlightSupportProjectionResponseToJSONTyped(json, false);
}

export function FlightSupportProjectionResponseToJSONTyped(
  value?: FlightSupportProjectionResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    itinerary_revision: value["itineraryRevision"],
    active_ticket_count: value["activeTicketCount"],
    loyalty_attachments:
      value["loyaltyAttachments"] == null
        ? undefined
        : (value["loyaltyAttachments"] as Array<any>).map(
            FlightLoyaltyAttachmentToJSON
          ),
    schema_version: value["schemaVersion"],
    booking_id: value["bookingId"],
    authoritative: value["authoritative"],
    state_version: value["stateVersion"],
    as_of: value["asOf"] == null ? value["asOf"] : value["asOf"].toISOString(),
    updated_at:
      value["updatedAt"] == null
        ? value["updatedAt"]
        : value["updatedAt"].toISOString(),
    provider: value["provider"],
    booking_status: value["bookingStatus"],
    payment_status: value["paymentStatus"],
    ticketing_status: value["ticketingStatus"],
    ticket_settlement_status: value["ticketSettlementStatus"],
    ticket_settlement_method: value["ticketSettlementMethod"],
    ticket_settlement_affected_count: value["ticketSettlementAffectedCount"],
    ticket_settlement_settled_count: value["ticketSettlementSettledCount"],
    cancellation_status: value["cancellationStatus"],
    refund_status: value["refundStatus"],
    order_evidence_present: value["orderEvidencePresent"],
    ticket_evidence_present: value["ticketEvidencePresent"],
    payment_approvals:
      value["paymentApprovals"] == null
        ? undefined
        : (value["paymentApprovals"] as Array<any>).map(
            FlightPaymentApprovalProjectionToJSON
          ),
    payment_approvals_total_count: value["paymentApprovalsTotalCount"],
    payment_approvals_truncated: value["paymentApprovalsTruncated"],
    capabilities:
      value["capabilities"] == null
        ? undefined
        : (value["capabilities"] as Array<any>).map(
            FlightSupportCapabilityToJSON
          ),
    recovery: FlightSupportRecoveryToJSON(value["recovery"]),
    attention: FlightSupportAttentionToJSON(value["attention"]),
    next_action: FlightSupportNextActionToJSON(value["nextAction"]),
    events:
      value["events"] == null
        ? undefined
        : (value["events"] as Array<any>).map(FlightSupportEventToJSON),
    truncated: value["truncated"],
    next_cursor: value["nextCursor"],
  };
}
